var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.901 1h3.68l-8.04 9.319L24 23h-7.406l-5.8-7.691L4.155 23H.474l8.6-9.968L0 1h7.594l5.243 7.03L18.901 1ZM17.61 20.766h2.039L6.486 3.116H4.298l13.312 17.65Z",
    fill: "currentColor"
  })));
};
export default SvgTwitter;